//  export const API_URL = 'https://localhost:5001/api';
export const API_URL = 'https://techassist-api.azurewebsites.net/api';
